/* istanbul ignore file */
import React from 'react';

import { MenuSection } from '@lumapps/lumx-menu/components/Menu/MenuSection';
import { MenuItemsSkeleton } from '@lumapps/lumx-menu/components/Menu/Skeleton/MenuItemsSkeleton';
import { GLOBAL, useTranslate } from '@lumapps/translations';
import { Suspense } from '@lumapps/utils/components/Suspense';

import { SettingsMenuSpacesProps } from './SettingsMenuSpaces';

const LazySettingsMenuSpaces = React.lazy(async () => {
    const resolved = await import(
        /* webpackChunkName: 'settings-menu-spaces' */
        './SettingsMenuSpaces'
    );

    return { default: resolved.SettingsMenuSpaces };
});

const SettingsMenuSpaces = (props: SettingsMenuSpacesProps) => {
    const { translateKey } = useTranslate();

    return (
        <Suspense
            loadingFallback={
                <MenuSection label={translateKey(GLOBAL.SPACE)}>
                    <MenuItemsSkeleton hasIcon itemCount={3} loadingMessage={translateKey(GLOBAL.LOADING)} />
                </MenuSection>
            }
        >
            <LazySettingsMenuSpaces {...props} />
        </Suspense>
    );
};

export { SettingsMenuSpaces };
